export default __webpack_public_path__ + "assets/images/fd297831448a15cfea69451b76c64260.png";